import { TPoint } from './points.model';

let points: TPoint[] = [];
let pointsById: {
  [_id: string]: TPoint;
} = {};

// Set

export const SET_POINTS = (_points: TPoint[]): void => {
  points = _points;

  points.forEach((_point) => {
    pointsById[_point._id] = _point;
  });
};

// Modify

// ---

// Clear

export const CLEAR_POINTS = (): void => {
  points.length = 0;
  pointsById = {};
};
